import './app';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

const application = Application.start();
const workingAtContext = require.context('./working-at-controllers', true, /\.js$/);
application.load(definitionsFromContext(workingAtContext));

const sharedContext = require.context('./shared-controllers', true, /\.js$/);
application.load(definitionsFromContext(sharedContext));

if (window.app.settings.leaveTabText) {
  let originalDocumentTitle;

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      originalDocumentTitle = document.title;
      document.title = window.app.settings.leaveTabText;
    } else if (originalDocumentTitle) {
      document.title = originalDocumentTitle;
    }
  });
}
